/* eslint-disable import/prefer-default-export */

export interface IDomain {
  id: number;
  type: string;
  title: string;
  homeDescription: {
    title: string;
    description: string;
  }[];
  detailDescription: {
    description: string;
  }[];
}
export interface IDomains extends Array<IDomain> {}

export const domains: IDomains = [
  /*
  * DROIT DES SOCIETES
  */
  {
    id: 1,
    type: "societes",
    title: "Droit des Sociétés - Fiscalité",
    homeDescription:[
      {
        title: "Constitution de tous types de sociétés",
        description: "SCI, SNC, SARL, SAS"
      },
      {
        title: "Transmission d’Entreprise",
        description: "Cession de fonds de commerce, Cession de titres"
      },
      {
        title: "Rédactions des Actes Juridiques",
        description: "Lettres d’Intention, Compromis, Acte de Cession, Garantie de Passif et Actif"
      },
    ],
    detailDescription:
    [
      {
        description: "Tous Types de Sociétés",
      },
      {
        description: "Transmission d’Entreprise : Rédactions des Actes Juridiques",
      },
      {
        description: "Baux Commerciaux",
      }
    ]
  },
  /*
  * DROIT COMMERCIAL
  */
  {
    id: 2,
    type: "commercial",
    title: "Droit Commercial",
    homeDescription:[
      {
        title: "Droit d'Entreprise",
        description: "Assistance devant le Tribunal de Commerce : Procédures de Recouvrement de Créances"
      },
      {
        title: "Baux Commerciaux",
        description: "Rédaction Baux Commerciaux"
      },
      {
        title: "Juge des Loyers",
        description: "Représentation devant le Juge des Loyers "
      },
    ],
    detailDescription:
    [
      {
        description: "Droit d'Entreprise",
      },
      {
        description: "Rédaction Baux Commerciaux",
      },
      {
        description: "Juge des Loyers",
      }
    ]
  },
  // /*
  // * DROIT FISCAL
  // */
  // {
  //   id: 3,
  //   type: "fiscality",
  //   title: "Fiscalité des Entreprises",
  //   homeDescription:[
  //     {
  //       title: "",
  //       description: "Sed maximum est in amicitia parem esse inferiori. Saepe enim excellentiae quaedam sunt, qualis erat Scipionis in nostro, ut ita dicam, grege. Numquam se ille Philo, numquam Rupilio, numquam Mummio anteposuit, numquam inferioris ordinis amicis, Q. vero Maximum fratrem, egregium virum omnino, sibi nequaquam parem, quod is anteibat aetate, tamquam superiorem colebat suosque omnes per se posse esse ampliores volebat. Sed maximum est in amicitia parem esse inferiori. Saepe enim excellentiae quaedam sunt, qualis erat Scipionis in nostro, ut ita dicam, grege. Numquam se ille Philo, numquam Rupilio, numquam Mummio anteposuit, numquam inferioris ordinis amicis, Q. vero Maximum fratrem, egregium virum omnino, sibi nequaquam parem, quod is anteibat aetate, tamquam superiorem colebat suosque omnes per se posse esse ampliores volebat."
  //     },
  // ],
  // detailDescription:
  //   [
  //     {
  //       description: "Constitution de tous types de sociétés",
  //     },
  //     {
  //       description: "Transmission d’entreprise",
  //     },
  //     {
  //       description: "Baux commerciaux",
  //     }
  //   ]
  // },
  /*
  * DROIT FAMILIAL
  */
  {
    id: 4,
    type: "family",
    title: "Droit de la Famille",
    homeDescription:[
      {
        title: "Procédures",
        description: "Divorce, Assistance Educative, Procédures devant le Juge aux Affaires Familiales Hors Divorce "
      },
  ],
  detailDescription:
    [
      {
        description: "Assistance Educative",
      },
      {
        description: "Divorce",
      },
    ]
  },
  /*
  * DROIT SOCIAL
  */
  {
    id: 5,
    type: "social",
    title: "Droit Social",
    homeDescription:[
      {
        title: "Procédures de Licenciement",
        description: "Tout Type de Licenciement, Rupture Conventionnelle, Mise en Place de CSE"
      },
    ],
    detailDescription:
    [
      {
        description: "Procédures de Licenciement",
      },
      {
        description: "Rupture Conventionnelle",
      },
      {
        description: "Mise en Place de CSE",
      }
    ]
  },
  /*
  * DROIT PENAL
  */
  {
    id: 6,
    type: "penal",
    title: "Droit Pénal",
    homeDescription:[
      {
        title: "Assistance & Représentation des victimes",
        description: "Comparution Immédiate, CRPC, Tribunal de Police, Juge d'Instruction"
      },
      {
        title: "Assistance & Représentation des Mises en Cause devant les Juridictions Pénales",
        description: ""
      },
      {
        title: "Tribunal pour Enfants",
        description: "Tribunal Correctionnel, etc."
      },
    ],
    detailDescription:
    [
      {
        description: "Assistance & Représentation des Victimes",
      },
      {
        description: "Assistance & Représentation des Mises en Cause devant les Juridictions Pénales",
      }
    ]
  },
];
